import { render } from "./ObrasOsStatusSelect.vue?vue&type=template&id=d46f5500"
import script from "./ObrasOsStatusSelect.vue?vue&type=script&lang=js"
export * from "./ObrasOsStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__